import { gql } from '@apollo/client'

export const SHOW_MY_FILTER_FOR_ZONE = gql`
  query ($zoneId: String) {
    showMyFilterForZone(zoneId: $zoneId)
  }
`
